// extracted by mini-css-extract-plugin
export default {"container":"DesktopContactEntry_container__s1Oiw","iconBubble":"DesktopContactEntry_iconBubble__kUOFe","value":"DesktopContactEntry_value__r0ufJ"};